import _styled from "@emotion/styled/base";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Children, useCallback, useState } from 'react';
import { Collapse } from '../../primitives/Collapse/index.js';
import { Container } from '../../primitives/CollapsibleSection/components/Container.js';
import { Items } from '../../primitives/CollapsibleSection/components/Items.js';
import { Stack } from '../../primitives/Stack/index.js';
import { SPACING_NONE } from '../../utils/spacingLegacy.js';
export const CollapsibleSection = /*#__PURE__*/_styled(({
  children,
  controls,
  expanded = false,
  maxVisibleItems = 5,
  height = 50,
  expandable = false,
  fade,
  stackProps = {
    spacing: SPACING_NONE
  },
  ...restProps
}) => {
  const [exitAnimationDone, setExitAnimationDone] = useState(false);
  const items = Children.toArray(children);
  const handleEnter = useCallback(() => {
    setExitAnimationDone(false);
  }, []);
  const handleExited = useCallback(() => {
    setExitAnimationDone(true);
  }, []);
  const areControlsNecessary = expandable && items.length > maxVisibleItems;
  return _jsxs(Container, {
    ...restProps,
    "data-testid": "collapsible-section",
    children: [_jsxs(Items, {
      height: height,
      fade: areControlsNecessary && fade,
      expanded: expanded,
      spacing: stackProps.spacing,
      divider: !exitAnimationDone && stackProps.divider,
      children: [_jsx(Stack, {
        ...stackProps,
        children: expandable ? items.slice(0, maxVisibleItems) : children
      }), areControlsNecessary && _jsx(_Fragment, {
        children: _jsx(Collapse, {
          in: expanded,
          mountOnEnter: true,
          onEnter: handleEnter,
          onExited: handleExited,
          children: _jsx(Stack, {
            ...stackProps,
            children: items.slice(maxVisibleItems)
          })
        })
      })]
    }), areControlsNecessary && controls]
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e7q4ezg0"
} : {
  target: "e7q4ezg0",
  label: "CollapsibleSection"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");